import {parseAxiosPromise} from '@/axiosInstance'
import {QUERY_KEYS} from '@/queryClient'
import {captureException} from '@sentry/react'
import {useQuery} from '@tanstack/react-query'
import {httpInsightMetrics} from '@features/insights/http/insights.http'
import {InsightMetrics} from '../types'
import {getStartDateForPeriod} from '../utils'

export const useGetInsightsMetrics = (period: 'last_month' | 'last_3_month' | 'last_6_month', enabled = true) => {
    const {startDate, endDate} = getStartDateForPeriod(period)
    return useQuery({
        queryKey: [QUERY_KEYS.INSIGHTS_METRICS, period],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpInsightMetrics({
                    params: {start_date: startDate, end_date: endDate}
                }),
                responseShape: InsightMetrics,
                onZodError: captureException
            }),
        enabled
    })
}
